import React, { FC } from 'react';
import { Colors } from '../../../../styles/colors';

interface Props {
  color: string;
}
export const ProductIconEchteWaerme: FC<Props> = ({ color = Colors.white }) => {
  return (
    <svg version="1.1" id="Untitled-Seite_201" xmlns="http://www.w3.org/2000/svg"
         xmlnsXlink="http://www.w3.org/1999/xlink" x="0px"
         y="0px" viewBox="0 0 1333.3 1141" style={{ color }} xmlSpace="preserve">
          <path className="st0" d="M0,0" style={{ fill: 'none' }} />
          <g id="Ebene_201" fill="currentColor">
            <path d="M1273.7,570.5c0,177.3-90.6,333.5-228,425.1c85.6-102.5,125.1-210.6,117.1-322.8C1141.7,378.7,804.7,158.2,737.4,117
              l-45-27.5l9.4,69.8c14.6,107.6,45,331.5-2.7,390.8c-5.5,6.8-11.3,10.2-18.2,10.7c-2.9,0.1-5.4-0.5-8.7-3.9
              c-24.7-25.3-28.7-124.9-23.6-187.5l5.2-64.5L606.5,349c-8.5,7.9-208,196.5-187.9,426.7c8.3,95.2,53.6,182.4,133.7,260.8
              c-178.3-79.9-302.6-258.3-302.6-466c0-282.2,229.2-511,512-511S1273.8,288.3,1273.7,570.5L1273.7,570.5z M761.7,1081.5
              c-28.8,0-56.8-2.9-84.2-7.5c-128.2-88.2-198.9-189.8-208.8-302.4c-12.5-141.5,72.8-270.1,127.8-337.2
              c0.9,54.9,8.6,125.5,39.8,157.5c13,13.4,29.3,20,48,18.9c21.2-1.7,39.8-11.8,53.9-29.3c52.5-65.2,39-231.8,18.2-392
              c104.2,72.3,340,259.9,356.3,486.9c9.6,133.2-58.7,262-202.2,383C862.2,1074.1,812.1,1081.5,761.7,1081.5L761.7,1081.5z
               M1333.3,570.5C1333.3,255.4,1077.4,0,761.7,0S190.1,255.4,190.1,570.5c0,162.4,68.3,308.6,177.4,412.5l0.1,0.2
              c25.4,26.4,19.3,60.7-11.5,74.3C328,1070,0,1141,0,1141h764.5l-0.9-0.1C1078.4,1139.9,1333.3,884.9,1333.3,570.5L1333.3,570.5z" />
          </g>
          <path className="st1" d="M0,0" fill="currentColor" />
    </svg>
  );
}
